import { render } from 'preact';
import { App } from './app.js';
import { boot } from './lib/khata.js';

render(<App />, document.getElementById('app')!);
void boot();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
